import { buildNativeDeepLinkPath } from "@features/payments/helpers"

export const REMINDER_ROUTE = "rmdr"
export const ORDERS_ROUTE = "orders"

export const isReminderDeepLinkRoute = (route: string) =>
  (route || "").startsWith(REMINDER_ROUTE)

export const restoreReminderCiphertext = (token: string) =>
  token.replace(/ /g, "+")

export const getReminderLinkIds = (
  search: string,
  state?: Record<string, string | undefined> | null
) => {
  const searchParams = new URLSearchParams(search)
  const nativeParams = state || {}
  const rawVehicleId = searchParams.get("v") || nativeParams.v || null
  const rawLicenseId = searchParams.get("l") || nativeParams.l || null
  const vehicleId = rawVehicleId
    ? restoreReminderCiphertext(rawVehicleId)
    : null
  const licenseId = rawLicenseId
    ? restoreReminderCiphertext(rawLicenseId)
    : null

  return {
    vehicleId,
    licenseId,
    redirectTo: vehicleId ? "/dashboard" : "/drivers-license",
  }
}

const hasMatchingReminderToken = (
  incoming: ReturnType<typeof getReminderLinkIds>,
  current: ReturnType<typeof getReminderLinkIds>
) => {
  if (incoming.vehicleId) {
    return current.vehicleId === incoming.vehicleId
  }
  if (incoming.licenseId) {
    return current.licenseId === incoming.licenseId
  }
  return false
}

export const resolveNativeDeepLink = (
  route: string,
  params: Record<string, string> | undefined,
  pathname: string,
  search = ""
) => {
  const safeParams = params || {}

  if (isReminderDeepLinkRoute(route)) {
    const alreadyHasToken =
      pathname.startsWith(`/${REMINDER_ROUTE}`) &&
      hasMatchingReminderToken(
        getReminderLinkIds("", safeParams),
        getReminderLinkIds(search)
      )

    return {
      kind: "reminder" as const,
      path: buildNativeDeepLinkPath(REMINDER_ROUTE, safeParams),
      params: safeParams,
      replace: true,
      skipNavigate: alreadyHasToken,
    }
  }

  return {
    kind: "spa" as const,
    path: buildNativeDeepLinkPath(route, safeParams),
    params: safeParams,
    replace: false,
    skipNavigate: false,
  }
}
